import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { Card } from './ui/Card';
export function ReviewsSection() {
  const reviews = [{
    name: 'Carolina M.',
    role: 'Mamá de 2, Contadora',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    text: 'Literalmente me devolvió la vida. Odiaba los domingos porque sabía que tenía que cocinar para toda la semana. Ahora pongo música, sigo el cronograma de 2 horas y listo. Las cenas en 5 minutos son reales.'
  }, {
    name: 'Valentina R.',
    role: 'Madre trabajadora',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    text: "Lo que más me gusta es que no comemos lo mismo todos los días. Las 'salsas mágicas' cambian por completo el sabor de los módulos. Mi esposo y mis hijos están felices y yo ya no pido delivery."
  }, {
    name: 'Daniela S.',
    role: 'Emprendedora',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    text: 'La lista de las 2 bolsas me ahorró muchísimo dinero. Antes compraba por comprar y botaba mucha verdura dañada. El sistema es a prueba de tontos, muy fácil de seguir.'
  }, {
    name: 'Mariana P.',
    role: 'Mamá primeriza',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    text: "Llegar a casa cansada y saber que la cena está lista en lo que me lavo las manos no tiene precio. La carga mental de 'qué cocino hoy' desapareció por completo de mi vida."
  }];
  return <section className="py-16 px-4 sm:px-6 bg-brand-bg" data-id="element-164">
      <div className="max-w-6xl mx-auto" data-id="element-165">
        <div className="text-center mb-12" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-167">
            Mujeres que ya recuperaron sus tardes
          </h2>
          <div className="flex justify-center gap-1 text-yellow-400 mb-4" data-id="element-168">
            {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} fill="currentColor" size={24} data-id="element-169" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-170">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-171">
              <Card className="h-full flex flex-col" data-id="element-172">
                <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-173">
                  {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} fill="currentColor" size={16} data-id="element-174" />)}
                </div>
                <p className="text-brand-text/80 italic mb-6 flex-grow" data-id="element-175">
                  "{review.text}"
                </p>
                <div className="flex items-center gap-4 mt-auto" data-id="element-176">
                  <img src={review.image} alt={review.name} className="w-12 h-12 rounded-full object-cover border-2 border-brand-light" data-id="element-177" />
                  <div data-id="element-178">
                    <h4 className="font-bold text-brand-text" data-id="element-179">{review.name}</h4>
                    <span className="text-sm text-brand-text/60" data-id="element-180">
                      {review.role}
                    </span>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}